// extracted by mini-css-extract-plugin
export default {"modal":"addVin_modal__+4aaR","form":"addVin_form__OWhVO","select":"addVin_select__+i-JQ"};